<template>
<div class="badge text-white" :class="variant">
    {{ status }}
</div>
</template>

<script>
import Vue from 'vue'
import { pspRequestStatusStr, pspRequestStatus, pspRequestVariant } from '@/constants/pspRequestStatus'
export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        status() {
            return pspRequestStatusStr.get(this.row.status)
        },
        variant() {
            return 'badge-'+pspRequestVariant(this.row.status)
        }
    }
})
</script>

<style>

</style>